module.exports = __webpack_public_path__ + "img/insta-g.f1b88b65.png";